import { injectIntl } from "react-intl";
import React from "react";
import apiService from "src/services/api.service";

const DeleteTag = (props) => {

    const deleteTag = () => {
        apiService.deleteTag(props.id).then(() => {
            props.close()
        })
    }

    return (
        <div className="NewStrategyModalOverlay">
            <div className="DeleteStrategyModal">
                <div className={ "w-full flex justify-between" }>
                    <div className={ "DeleteStrategy" }>
                        <img alt={ "Logo" } src={ "/media/icons/deleteIcon.svg" } className={ "w-[18px] h-[18px]" }/>
                        Are you sure you want to delete “{props.name}” tag
                    </div>
                    <button className={ "CloseIconButton" } onClick={ props.close }>
                        <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" } className={ "w-5 h-5" }/>
                    </button>
                </div>
                <div className={ "flex flex-col gap-4 w-full" }>
                    <div className={ "HorizontalDivider" }></div>
                    <div className={ "StrategyDeleteWarning" }>
                        Are you sure you want to delete “{props.name}” tag? This action cannot be undone.
                    </div>
                    <div className={ "HorizontalDivider" }></div>
                </div>
                <div className={ "modal-actions" }>
                    <button className={ "CloseButton" } onClick={ props.close }>Cancel</button>
                    <button className={ "DeleteButton" } onClick={ deleteTag }>Delete</button>
                </div>
            </div>
        </div>
    );
}

export default injectIntl(DeleteTag);
